var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6253 16.7582H8.50494L6.91495 10.6924C6.83949 10.4133 6.67925 10.1667 6.44354 10.0504C5.85531 9.75823 5.20712 9.5257 4.5 9.40843V9.1749H7.91567C8.38708 9.1749 8.74064 9.5257 8.79957 9.93313L9.62454 14.3086L11.7438 9.1749H13.8052L10.6253 16.7582ZM14.9838 16.7582H12.9813L14.6302 9.1749H16.6327L14.9838 16.7582ZM19.2234 11.2757C19.2823 10.8673 19.6359 10.6337 20.0483 10.6337C20.6965 10.5751 21.4026 10.6924 21.9919 10.9835L22.3454 9.35081C21.7562 9.11727 21.108 9 20.5198 9C18.5762 9 17.162 10.0504 17.162 11.5082C17.162 12.6173 18.1637 13.1996 18.8708 13.5504C19.6359 13.9002 19.9305 14.1338 19.8716 14.4835C19.8716 15.0082 19.2823 15.2418 18.6941 15.2418C17.9869 15.2418 17.2798 15.0669 16.6327 14.7747L16.2791 16.4085C16.9862 16.6996 17.7512 16.8169 18.4584 16.8169C20.6376 16.8745 21.9919 15.8251 21.9919 14.25C21.9919 12.2665 19.2234 12.1502 19.2234 11.2757ZM29 16.7582L27.41 9.1749H25.7022C25.3486 9.1749 24.9951 9.40843 24.8772 9.75823L21.9329 16.7582H23.9943L24.4058 15.6502H26.9386L27.1743 16.7582H29ZM25.9968 11.2171L26.585 14.0751H24.9361L25.9968 11.2171Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.3149da5fb3d6739810ee734a7e34f533.svg";
export { ForwardRef as ReactComponent };